import { Colors } from "@eai-toolkit-material-ui/theme";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { tracker } from "@openreplay/tracker";
import { Link } from "react-router-dom";

import {
  CREATE_NEW_JOB_ROUTE,
  EAI_CONSOLE_HOST,
  EAI_CONSOLE_PROTOCOL,
  JOBS_ROUTE,
  NOTEBOOKS_ROUTE,
  PRODUCT_NAME_TOOLKIT,
} from "@helpers/constants";
import { DASHBOARD_EVENTS } from "@helpers/events";

import EaiCards from "./EaiCards";

export type CardsLayout = "row" | "column";
const WelcomeContent = styled("div")(({ theme }) => ({
  display: "grid",
  gridAutoFlow: "row",
  gap: theme.spacing(0.5),
  "& a": { textDecoration: "none", color: Colors.purple[500] },
}));

const Welcome = (props: { sx?: SxProps<Theme>; layout?: CardsLayout }) => {
  return (
    <Box sx={props.sx}>
      <WelcomeContent>
        <div>
          <Typography
            component="p"
            sx={(theme) => ({
              fontSize: "14px",
              [theme.breakpoints.up("md")]: { fontSize: "16px" },
              mb: "10px",
            })}
          >
            Here you can{" "}
            <Link
              to={CREATE_NEW_JOB_ROUTE}
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.CREATE_JOB_LINK_CLICKED)
              }
            >
              create
            </Link>{" "}
            and{" "}
            <Link
              to={JOBS_ROUTE}
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.MONITOR_JOBS_LINK_CLICKED)
              }
            >
              monitor
            </Link>{" "}
            jobs,{" "}
            <Link
              to={NOTEBOOKS_ROUTE}
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.LAUNCH_NOTEBOOKS_LINK_CLICKED)
              }
            >
              launch notebooks
            </Link>{" "}
            and{" "}
            <MuiLink
              href={`${EAI_CONSOLE_PROTOCOL}//docs.${EAI_CONSOLE_HOST}/pages/use_cases/large_model_training.html`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.TRAIN_MODELS_LINK_CLICKED)
              }
            >
              train your own models
            </MuiLink>
            .
            <wbr />
          </Typography>
          <Typography
            component="p"
            sx={(theme) => ({
              mb: "14px",
              fontSize: "14px",
              [theme.breakpoints.up("md")]: { fontSize: "16px" },
            })}
          >
            To get started, head over to the{" "}
            <a
              href={`${EAI_CONSOLE_PROTOCOL}//docs.${EAI_CONSOLE_HOST}/pages/tutorial.html#install-the-cli`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.VIEW_DOCUMENTATION_LINK_CLICKED)
              }
            >
              {PRODUCT_NAME_TOOLKIT} docs
            </a>{" "}
            to begin installing the CLI.
            <br />
          </Typography>
          <EaiCards direction={props.layout} />
          <Typography
            component="p"
            color="text.secondary"
            sx={{
              fontSize: "12px",
            }}
          >
            Read the{" "}
            {/* Safe link to ServiceNow website */
            /* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              href={"https://www.servicenow.com/terms-of-use.html#toolkit"}
              target="_blank"
              onClick={() =>
                tracker.event(DASHBOARD_EVENTS.TERMS_OF_USE_LINK_CLICKED)
              }
            >
              {PRODUCT_NAME_TOOLKIT} Terms of Use
            </a>
          </Typography>
        </div>
      </WelcomeContent>
    </Box>
  );
};

export default Welcome;
